// Lightweight GA loader and helpers (landing-only)
// Hardcoded measurement ID: replace with your real ID if desired.
const HARDCODED_GA_ID = 'G-KGW5S2QE90';

export function loadGtag(measurementId = HARDCODED_GA_ID) {
  return new Promise((resolve) => {
    if (!measurementId || typeof window === 'undefined') { resolve(false); return; }

    // already loaded
    if (window.gtag) { resolve(true); return; }

    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

      const onLoad = () => {
        try {
          window.dataLayer = window.dataLayer || [];
          const gtag = function() { window.dataLayer.push(arguments); };
          window.gtag = gtag;

          window.gtag('js', new Date());
          // prevent automatic page view; we'll send it manually from React
          window.gtag('config', measurementId, { send_page_view: false });
          cleanup();
          resolve(true);
        } catch (e) {
          cleanup();
          resolve(false);
        }
      };

      const onError = () => {
        cleanup();
        resolve(false);
      };

      const cleanup = () => {
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
      };

      script.addEventListener('load', onLoad);
      script.addEventListener('error', onError);

      try {
        document.head.appendChild(script);
      } catch (e) {
        // appendChild can be blocked by extensions; handle gracefully
        cleanup();
        resolve(false);
      }

      // safety timeout in case neither load nor error fires
      setTimeout(() => {
        if (!window.gtag) {
          cleanup();
          resolve(false);
        }
      }, 5000);
    } catch (e) {
      resolve(false);
    }
  });
}

export function trackPage(path) {
  if (typeof window === 'undefined' || !window.gtag) { return; }
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackEvent({ category, action, label, value }) {
  if (typeof window === 'undefined' || !window.gtag) { return; }
  window.gtag('event', action, { event_category: category, event_label: label, value });
}
